/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pxk_Reject_TitleInputs */

const vi_pl_pxk_reject_title = /** @type {(inputs: Pl_Pxk_Reject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối PXK lô chè mua`)
};

/**

* @param {Pl_Pxk_Reject_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pxk_reject_title = /** @type {((inputs?: Pl_Pxk_Reject_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pxk_Reject_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pxk_reject_title(inputs)
});